import { render, staticRenderFns } from "./ModalRedeemCode.vue?vue&type=template&id=534fae6c&scoped=true"
import script from "./ModalRedeemCode.vue?vue&type=script&lang=js"
export * from "./ModalRedeemCode.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeemCode.vue?vue&type=style&index=0&id=534fae6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534fae6c",
  null
  
)

export default component.exports